<template>
	<card layout="table" tag="section" responsive @resize="onResize">
		<template #default>
			<loading v-if="loading"></loading>
			<div v-else class="b-table">
				<assignment-table :data="assignments" :width="cardWidth" :per-page="perPage"></assignment-table>
			</div>
		</template>
	</card>
</template>
<script>
	import { ref, computed, inject, onMounted } from "vue";
	import { assignmentTable } from "@/components/tables";
	export default {
		props: {
			take: {
				type: [String, Number],
				default: 5
			},
			perPage: {
				type: Number,
				default: 50
			},
			filters: {
				type: Object,
				default: () => {
					return {};
				}
			}
		},
		components: {
			assignmentTable
		},
		setup(props, context) {
			const moment = inject("$moment");
			const $http = inject("$http");

			const loading = ref(true);
			const assignments = ref([]);

			const GetAssignments = async () => {
				loading.value = true;

				try {
					const response = await $http.post("/api/v2/widget/recentAssignments", {
						filter: props.filters?.keys || [],
						take: props.take || undefined
					});
					assignments.value = response.data;
				} catch (err) {
					console.error(err);
				}

				loading.value = false;
			};

			const cardWidth = ref(0);
			const timer = ref(null);
			const onResize = (width) => {
				clearTimeout(timer.value);
				timer.value = setTimeout(() => {
					cardWidth.value = width;
				}, 100);
			};

			onMounted(() => {
				GetAssignments();
			});

			return {
				moment,
				loading,
				assignments,
				cardWidth,
				timer,
				onResize
			};
		}
	};
</script>
